<div class="bv-send-extra-options" [formGroup]="sendOptionsForm">
  @if (editing()) {
    <bit-form-field class="bv-send-field">
      <bit-label>{{ "maxAccessCount" | i18n }}</bit-label>
      <input bitInput formControlName="maxAccessCount" id="maxAccessCountInput" />
      <bit-hint>{{ "limitSendViewsHint" | i18n }}</bit-hint>
    </bit-form-field>
  } @else if (maxAccessCountVisible()) {
    <bit-form-field class="bv-send-field">
      <bit-label>{{ "maxAccessCount" | i18n }}</bit-label>
      <input bitInput formControlName="maxAccessCount" readonly id="maxAccessCountInput" />
      @if (showAccessCount()) {
        <bit-hint>{{ "limitSendViewsCount" | i18n: viewsLeft() }}</bit-hint>
      }
    </bit-form-field>
  }

  @if (editing()) {
    <bit-form-field class="bv-send-field">
      <bit-label>{{ "notes" | i18n }}</bit-label>
      <textarea bitInput rows="3" formControlName="notes"></textarea>
      <bit-hint>{{ "bvSendNotesHint" | i18n }}</bit-hint>
    </bit-form-field>
  } @else if (privateNoteVisible()) {
    <bit-form-field class="bv-send-field">
      <bit-label>{{ "notes" | i18n }}</bit-label>
      <textarea bitInput rows="3" formControlName="notes" readonly></textarea>
    </bit-form-field>
  }
</div>
